import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Product, { SaleBoom } from "@/model/product";
import i18n from "@/i18n";
import { makeid } from "@/common/utils";
import { namespace } from "vuex-class";
import store from "@/store";

@Module({ namespaced: true })
export default class CartModule extends VuexModule {
  accountCodeCart: any = {};
  private static readonly ORDER_LIMIT: number = 96;
  isLimitAddToCart = false;

  @Mutation
  removeItemCart(index) {
    const accountCode = store.state.Auth.customer_user?.account_code;
    this.accountCodeCart['cart_' + accountCode].splice(index, 1);
  }

  @Mutation
  addItemToCart(products: any[]) {
    const addItems = [];
    this.isLimitAddToCart = false;

    products.map((product: any) => {
      addItems.push({
        set_item_code: product.set_item_code || null,
        item_code: product.item_code,
        cart_quanlity: product.cart_quanlity - 0,
        uuid: makeid()
      });
      return product;
    });

    const accountCode = store.state.Auth.customer_user?.account_code;
    let items = this.accountCodeCart['cart_' + accountCode] || [];
    
    if ([...items, ...addItems].length > CartModule.ORDER_LIMIT) {
      this.isLimitAddToCart = true;
      return;
    }

    items = [...items, ...addItems];
    items = items.filter(item => item.cart_quanlity && item.cart_quanlity > 0);
    
    this.accountCodeCart = {
      ...this.accountCodeCart,
      ['cart_' + accountCode]: items
    }
  }

  @Mutation
  replaceItemCart(data) {
    const accountCode = store.state.Auth.customer_user?.account_code;
    this.accountCodeCart['cart_' + accountCode] = data;
  }

  @Mutation
  modifier(item) {
    const accountCode = store.state.Auth.customer_user?.account_code;
    const cart = this.accountCodeCart['cart_' + accountCode].find(cart => item.uuid === cart.uuid );
    if (cart) {
      cart.cart_quanlity = item.cart_quanlity - 0;
    }
  }

  @Action({ rawError: true })
  async addCart(product: Product[] | SaleBoom[]): Promise<void> {
    this.context.commit("addItemToCart", product);
    if (this.isLimitAddToCart) {
      throw new Error(i18n.ja.cart_page.messsage.order_limit_to_cart);
    }
  }

  @Action({ rawError: true })
  async cartRemove(index) {
    this.context.commit("removeItemCart", index);
  }

  @Action({ rawError: true })
  async replaceCart(data) {
    this.context.commit("replaceItemCart", data);
  }

  @Action({ rawError: true })
  async updateItem(item) {
    this.context.commit("modifier", item);
  }

  get totalItems() {
    const accountCode = store.state.Auth.customer_user?.account_code;
    const cart = this.accountCodeCart['cart_' + accountCode];
    return cart ? cart.length : 0;
  }

  get cartItems() {
    const accountCode = store.state.Auth.customer_user?.account_code;
    return this.accountCodeCart['cart_' + accountCode] || [];
  }

  get isLimitAddCart() {
    return this.isLimitAddToCart;
  }

  // get subTotal(): number {
  //   return _.reduce(
  //     this.getItems,
  //     (memo, item) => {
  //       return memo + item.subTotal;
  //     },
  //     0
  //   );
  // }
  // get subTax(): number {
  //   return _.reduce(
  //     this.getItems,
  //     (memo, item) => {
  //       return memo + item.tax;
  //     },
  //     0
  //   );
  // }

  // get total(): number {
  //   return this.subTotal + this.subTax;
  // }

  // get hasProductionDeleted(): boolean {
  //   return (
  //     _.reduce(
  //       this.getItems,
  //       (memo, item) => {
  //         return memo + item.isProductDeleted;
  //       },
  //       0
  //     ) > 0
  //   );
  // }

  // get getDisableDeliveryDate(): string[] {
  //   let list: string[] = [];
  //   for (const item of this.getItems) {
  //     list = [...list, ...item.item_carton.getDisableDeliveryDay];
  //   }
  //   return list;
  // }
}
